var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIndeterminateCheckBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63636 0C1.62806 0 0 1.62806 0 3.63636V12.3636C0 14.3719 1.62806 16 3.63636 16H12.3636C14.3719 16 16 14.3719 16 12.3636V3.63636C16 1.62806 14.3719 0 12.3636 0H3.63636ZM11.5556 8.88893H4.44446C3.95558 8.88893 3.55558 8.48893 3.55558 8.00004C3.55558 7.51115 3.95558 7.11115 4.44446 7.11115H11.5556C12.0445 7.11115 12.4445 7.51115 12.4445 8.00004C12.4445 8.48893 12.0445 8.88893 11.5556 8.88893Z",
    fill: "#426AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIndeterminateCheckBox);
export default __webpack_public_path__ + "static/media/ic-Indeterminate-check-box.f3fe14b9e90ec67386acb495e4ecc118.svg";
export { ForwardRef as ReactComponent };